export default __webpack_public_path__ + "static/media/grp2.91362853.jpeg";